import "./utilities_namespace.js";

// Proxies the event to the parent element while adding the given `eventDetail`.
// A common use case is to tag analytics events within a particular container with specific metadata.
// NOTE: Propagation of the original event is halted at the current element and a new event is generated with the details.
//       Calling setEventDetail multiple times on the same element will duplicate the observed event once for each call.

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

Sparkle.Utilities.setEventDetail = (element, eventName, eventDetail) =>
  jQuery(element).on(eventName, (event, ...payload) => {
    event.stopPropagation();
    const detail = {
      ...event.detail,
      ...eventDetail,
    };
    const newEvent = jQuery.Event(event, { namespace: event.namespace, target: event.target, detail });
    return jQuery(element).parent().trigger(newEvent, payload);
  });
